export type ThemeName = "default" | "rebrand";

export const THEME_ATTRIBUTE = "data-theme";

/**
 * URL switch for the rebrand theme. Deliberately not a FEATURE_FLAGS entry so
 * the omnibox never lists it; `appendCurrentFlags` still carries it across
 * in-app navigation.
 */
export const REBRAND_SEARCH_PARAM = "rebrand";

/**
 * Themes are CSS-only: rebrand.css scopes its overrides under
 * :root[data-theme="rebrand"]. Default theme means no attribute.
 */
export const applyThemeToDocument = (
  theme: ThemeName,
  root: HTMLElement = document.documentElement,
): void => {
  if (theme === "default") {
    root.removeAttribute(THEME_ATTRIBUTE);
    return;
  }
  root.setAttribute(THEME_ATTRIBUTE, theme);
};
